import React, { useMemo } from 'react'

import { ArgylePrepData, ConnectorId, DirectTask, StrategyInfo } from '@frame/lib/api/tasks/types'
import { trackView } from '@frame/lib/tracking'

import { ArgyleScreen } from './argyle'
import { SandboxScreen } from './sandbox'

const connectorScreens = (data: StrategyInfo['prep_data'], task: DirectTask) => {
  return {
    [ConnectorId.ARGYLE]: () => <ArgyleScreen data={data as ArgylePrepData} task={task} />,
    [ConnectorId.SANDBOX]: () => <SandboxScreen task={task} />,
    [ConnectorId.FINICITY]: () => {
      throw Error('Unconfigured for Finicity')
    },
  }
}

type Props = {
  task?: DirectTask
}

export function ConnectorScreen({ task }: Props) {
  const strategyInfo = task?.strategy_info

  if (!strategyInfo) {
    throw new Error('Failed to load strategy_info from task')
  }

  trackView(`credentials/partner/${strategyInfo.connector_id}`)

  return useMemo(() => {
    const Component = connectorScreens(strategyInfo.prep_data, task)[strategyInfo.connector_id]
    return <Component />
  }, [strategyInfo.prep_data, strategyInfo.connector_id, task])
}
